import { useEffect, useState } from '@wordpress/element';
import { useAnalisesParametrosWp } from './useAnalisesParametrosWp';
import { useAnalisesParametrosEditorJs } from './useAnalisesParametrosEditorJs';
import { useSelect } from '@wordpress/data';
import { store } from '../../redux/store';

export const useAnalisesPostParametros = ({ idPost = 0, tipo = '' }) => {
  const idUsuario = useSelect(select => select(store).getUsuarioIdOpti());
  const [parametros, setParametros] = useState({
    idUsuarioWordpress: parseInt(
      localStorage.getItem('id_usuario_wp') ?? `${idUsuario != 0 ? idUsuario : 0}`
    ),
    idArtigoWp: parseInt(idPost),
  });

  const { gerarParametrosWp, parametros: parametrosWp } = useAnalisesParametrosWp({ idPost, tipo });
  const { gerarParametrosJs, parametros: parametrosSeo } = useAnalisesParametrosEditorJs();

  const obterParametro = () => {
    if (tipoEditor() === 'wp') {
      gerarParametrosWp();
      return;
    }

    gerarParametrosJs();
  };

  function tipoEditor() {
    const url = window.location.href;
    if (url.includes('criar-artigo=true') || url.includes('editar-artigo')) return 'js';

    return 'wp';
  }

  useEffect(() => {
    if (parametrosWp) {
      setParametros(prev => ({ ...prev, ...parametrosWp }));
    }

    if (parametrosSeo) {
      setParametros(prev => ({ ...prev, ...parametrosSeo }));
    }
  }, [parametrosWp, parametrosSeo]);

  return {
    tipoEditor: tipoEditor(),
    parametros,
    obterParametro,
  };
};
